import React, { useState, useEffect, Fragment } from "react";

import Main from "./main";
import Timer from "./main/timer";
import Hard from "./hard";
import Medium from "./medium";
import Easy from "./easy";

function Layout() {
  const [phase, setPhase] = useState("");
  const [main, setMain] = useState(false);
  const [timer, setTimer] = useState(false);
  const [game, setGame] = useState(false);
  const [level, setLevel] = useState("");

  useEffect(
    () => {
      setLevel(localStorage.getItem("level"));
      setPhase(localStorage.getItem("phase"));
      if (phase === "timer") {
        setTimer(true);
      } else if (phase === "game") {
        setGame(true);
      } else {
        setMain(true);
      }
    },
    [phase]
  );

  return phase === "timer"
    ? <Timer setPhase={setPhase} />
    : phase === "game"
      ? level === "hard"
        ? <Hard setPhase={setPhase} />
        : level === "medium"
          ? <Medium setPhase={setPhase} />
          : <Easy setPhase={setPhase} />
      : <Main setPhase={setPhase} />;
}

export default Layout;
